import api from ".";


export default {
    getUsers: async (page = 1, limit = 10, verified) => {
        try {
            const res = await api.get(`/api/admin/users`, {
                params: {
                    page,
                    limit,
                    verified
                }
            });
            return res.data;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },

    getUser: async (id) => {
        try {
            const res = await api.get(`/api/admin/users/${id}`);
            return res.data;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },

    setUserRole: async (id, role) => {
        try {
            const res = await api.put(`/api/admin/users/${id}`, { role });
            return res.data;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },
}